import { logInfo } from "../utils/log";
import { RuleAction } from "./RuleAction";
import { isElementFullMatch } from "./isElementFullMatch";

export const findFullMatch = (
  action: RuleAction,
  elements: HTMLElement[]
): HTMLElement | null => {
  if (!action.selector) return null;

  // First check if we have an ID in attributes and find matching elements
  // When there's exactly one element with that ID, return it immediately
  // When ID is null or multiple elements have same ID, use innerText matching
  if (action.attributes.id) {
    const elementsWithId = elements.filter(
      (element) => element.id === action.attributes.id
    );
    
    // If exactly one element has this ID, return it immediately (ignore innerText)
    if (elementsWithId.length === 1) {
      logInfo("Single element with ID found, returning immediately");
      return elementsWithId[0];
    }
    
    // If multiple elements have the same ID, continue with normal matching
    if (elementsWithId.length > 1) {
      logInfo("Multiple elements with same ID found, will use innerText matching");
    }
  }

  const matchesWithoutInnerText = elements.filter(isElementFullMatch(action));

  logInfo("Matches without innerText: ", matchesWithoutInnerText);

  if (matchesWithoutInnerText.length === 0) return null;

  const fullMatch = matchesWithoutInnerText.find((element) => {
    return element?.innerText === action.attributes.innerText;
  });

  if (fullMatch) return fullMatch;
  if (matchesWithoutInnerText.length > 1) {
    logInfo("Multiple elements matched but none with innerText");
  }
  if (matchesWithoutInnerText.length > 3) return null;

  return matchesWithoutInnerText[0];
};
